module.exports = __webpack_public_path__ + "img/finanzas.a152051f.svg";